import { constructPatchDataByKey } from '../utils'
import finishedPatchOptionsData from './finished-patch-option-data.json'
import finishedPatchPrefixData from './finished-patch-prefix-data.json'
import patchOptionsData from './patch-option-data.json'
import patchPrefixes from './patch-prefix-data.json'
import JSONData from './welldecoratedjacket.json'
//import productData from './product-data.json'

const getJPIData = () => {
    try {
        return JSON.parse(document.getElementById('jpi-data').innerHTML)
    } catch (error) {
        // console.log("No Data found on page. Reverting to LOCAL JSON data.")
        return JSONData
    }
}

const getProductData = () => {
    try {
        return JSON.parse(document.getElementById('product-data').innerHTML)
    } catch (error) {
        // console.log("No Product Data found on page.")
        return null
    }
}

const getGoogleAnalyticsObject = () => {
    if (typeof window.dataLayer === 'undefined' || window.dataLayer === null) {
        //console.log("Google Analytics page not available at this time")
        return null
    }
    return window.dataLayer
}

const constructedPatchData = constructPatchDataByKey(
    patchPrefixes,
    patchOptionsData,
    'JacketPatchConfiguratorOptionData',
    'JacketPatchConfiguratorPrefixData'
);

const constructedSportFinishPatchData = constructPatchDataByKey(
    finishedPatchPrefixData,
    finishedPatchOptionsData,
    'JacketSportFinishPatchConfiguratorOptionData',
    'JacketSportFinishPatchConfiguratorPrefixData'
);

export const AppData = {
    jpidata: getJPIData(),
    productdata: getProductData(),
    gaobject: getGoogleAnalyticsObject(),
    patchdata: constructedPatchData,
    sportFinishPatchData: constructedSportFinishPatchData,
}